import { useEffect, useRef, useState } from "react";
import { api } from "../api";
import { ALL_LEAGUES, getWeekRange } from "../constants";
import { useIsMobile } from "../useIsMobile";
import KalibrasyonView from "./KalibrasyonView";
import GununMaclari from "./GununMaclari";



function predCode(pred) {
  if (!pred) return null;
  const p = pred.toLowerCase();
  if (p.includes("beraberlik")) return "X";
  if (p.includes("deplasman") || p.includes("away")) return "2";
  return "1";
}

function LeagueStats({ league, predictions, compact = false }) {
  // Tüm Ligler seçiliyse tüm tahminler, değilse sadece o lig
  const allPreds  = league === "Tüm Ligler"
    ? (predictions || [])
    : (predictions || []).filter(p => p.league === league);

  // Sonuçlanmış tahminler
  const completed = allPreds.filter(p => p.actual_result);
  const pending   = allPreds.filter(p => !p.actual_result);
  const total     = completed.length;

  const correct = completed.filter(p => {
    const pred = (p.gpt_prediction || p.prediction || "").toLowerCase();
    const predNorm = pred.includes("beraberlik") ? "draw"
      : (pred.includes("deplasman") || pred.includes("away")) ? "away_win"
      : "home_win";
    return predNorm === p.actual_result;
  }).length;
  const wrong    = total - correct;
  const accuracy = total > 0 ? Math.round(correct / total * 100) : null;
  const accColor = accuracy === null ? "#9ca3af" : accuracy >= 55 ? "#16a34a" : accuracy >= 40 ? "#f59e0b" : "#dc2626";

  // Bir maç raporu açıkken tam çubuk yerine tek satırlık ince şerit —
  // dikey alanı rapora bırakır.
  if (compact) return (
    <div style={{ padding:"6px 14px", borderBottom:"1px solid #eee", background:"#f9fafb",
                  display:"flex", alignItems:"center", gap:14, fontSize:11, flexShrink:0, overflowX:"auto", whiteSpace:"nowrap" }}>
      <span style={{ fontWeight:700, color:"#374151" }}>{league}</span>
      <span style={{ color:"#6b7280" }}>Tahmin <b style={{ color:"#2563eb" }}>{total}</b></span>
      <span style={{ color:"#6b7280" }}>Başarı <b style={{ color:accColor }}>{accuracy !== null ? `%${accuracy}` : "—"}</b></span>
      <span style={{ color:"#6b7280" }}>Doğru <b style={{ color:"#16a34a" }}>{correct}</b></span>
      <span style={{ color:"#6b7280" }}>Yanlış <b style={{ color:"#dc2626" }}>{wrong}</b></span>
      <span style={{ color:"#6b7280" }}>Bekleyen <b style={{ color:"#9ca3af" }}>{pending.length}</b></span>
    </div>
  );

  return (
    <div style={{ padding:"14px 16px", borderBottom:"1px solid #eee", background:"#f9fafb" }}>
      <div style={{ fontSize:12, fontWeight:700, color:"#374151", marginBottom:10 }}>
        {league} — Tahmin İstatistikleri
      </div>
      <div style={{ display:"flex", gap:0 }}>
        {[
          { label:"Tahmin", value: total,    color:"#2563eb" },
          { label:"Başarı", value: accuracy !== null ? `%${accuracy}` : "—", color: accColor },
          { label:"Doğru",  value: correct,  color:"#16a34a" },
          { label:"Yanlış", value: wrong,    color:"#dc2626" },
          { label:"Bekleyen", value: pending.length, color:"#9ca3af" },
        ].map(({ label, value, color }) => (
          <div key={label} style={{ flex:1, textAlign:"center", padding:"4px 0" }}>
            <div style={{ fontSize:18, fontWeight:700, color }}>{value}</div>
            <div style={{ fontSize:10, color:"#9ca3af", marginTop:2 }}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}




const C_AI = {
  claude: { color: "#d97706", bg: "#fffbeb", border: "#fcd34d", icon: "🟠" },
  gpt:    { color: "#10b981", bg: "#ecfdf5", border: "#6ee7b7", icon: "🟢" },
};

function ReportPanel({ prediction: pred, onClose }) {
  const [aiTab, setAiTab] = useState("gpt");
  const [activeReport, setActiveReport] = useState("form");

  if (!pred) return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", height:"100%", color:"#ccc", fontSize:13 }}>
      <div style={{ fontSize:32, marginBottom:8 }}>👈</div>
      Bir maça tıkla
    </div>
  );

  const reports = aiTab === "claude" ? pred.claude_reports : pred.gpt_reports;
  const aiPred  = aiTab === "claude" ? (pred.claude_prediction || (pred.ai_provider==="claude" ? pred.prediction : null))
                                     : (pred.gpt_prediction    || (pred.ai_provider==="gpt"    ? pred.prediction : null));
  const aiHp    = aiTab === "claude" ? (pred.claude_home_pct  ?? (pred.ai_provider==="claude" ? pred.home_pct  : null))
                                     : (pred.gpt_home_pct     ?? (pred.ai_provider==="gpt"    ? pred.home_pct  : null));
  const aiDp    = aiTab === "claude" ? (pred.claude_draw_pct  ?? (pred.ai_provider==="claude" ? pred.draw_pct  : null))
                                     : (pred.gpt_draw_pct     ?? (pred.ai_provider==="gpt"    ? pred.draw_pct  : null));
  const aiAp    = aiTab === "claude" ? (pred.claude_away_pct  ?? (pred.ai_provider==="claude" ? pred.away_pct  : null))
                                     : (pred.gpt_away_pct     ?? (pred.ai_provider==="gpt"    ? pred.away_pct  : null));
  const aiConf  = aiTab === "claude" ? (pred.claude_confidence ?? (pred.ai_provider==="claude" ? pred.confidence : null))
                                     : (pred.gpt_confidence   ?? (pred.ai_provider==="gpt"    ? pred.confidence : null));
  const aiReason= aiTab === "claude" ? (pred.claude_reasoning  || (pred.ai_provider==="claude" ? pred.reasoning : null))
                                     : (pred.gpt_reasoning     || (pred.ai_provider==="gpt"    ? pred.reasoning : null));
  const cfg = C_AI[aiTab];
  const winner = !aiPred ? null
    : (aiPred==="Beraberlik"||aiPred?.toLowerCase()==="beraberlik") ? "draw"
    : (aiPred?.toLowerCase().includes("deplasman")||aiPred?.toLowerCase().includes("away")) ? "away"
    : "home";

  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100%", overflow:"hidden" }}>
      {/* Header */}
      <div style={{ padding:"12px 16px", borderBottom:"1px solid #eee", display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexShrink:0 }}>
        <div>
          <div style={{ fontSize:13, fontWeight:700, color:"#111" }}>{pred.home} vs {pred.away}</div>
          <div style={{ fontSize:11, color:"#888" }}>{pred.league} · {pred.match_date}</div>
        </div>
        <button onClick={onClose} style={{ background:"none", border:"none", fontSize:18, cursor:"pointer", color:"#999" }}>×</button>
      </div>

      {/* AI Tab */}
      <div style={{ display:"flex", borderBottom:"1px solid #eee", flexShrink:0 }}>
        {["claude","gpt"].map(p => (
          <button key={p} onClick={() => { setAiTab(p); setActiveReport("form"); }} style={{
            padding:"8px 16px", fontSize:12, border:"none",
            borderBottom: aiTab===p ? `2px solid ${C_AI[p].color}` : "2px solid transparent",
            background:"transparent", cursor:"pointer",
            color: aiTab===p ? C_AI[p].color : "#9ca3af",
            fontWeight: aiTab===p ? 700 : 400,
          }}>
            {C_AI[p].icon} {p==="claude" ? "Claude" : "GPT-4o"}
          </button>
        ))}
      </div>

      {/* Tahmin özeti */}
      {aiPred && (
        <div style={{ padding:"10px 14px", background:cfg.bg, borderBottom:"1px solid #eee", flexShrink:0 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
            <span style={{ fontSize:18 }}>{winner==="home"?"🏠":winner==="away"?"✈️":"🤝"}</span>
            <span style={{ fontSize:14, fontWeight:700, color:cfg.color }}>{aiPred}</span>
            {aiConf != null && <span style={{ marginLeft:"auto", fontSize:11, color:"#9ca3af", background:"#fff", padding:"2px 8px", borderRadius:12, border:"1px solid #e5e7eb" }}>Güven: {aiConf}/100</span>}
          </div>
          {aiHp != null && (
            <>
              <div style={{ display:"flex", height:7, borderRadius:4, overflow:"hidden", gap:1, marginBottom:4 }}>
                <div style={{ flex:aiHp, background:"#2563eb" }}/><div style={{ flex:aiDp, background:"#d97706" }}/><div style={{ flex:aiAp, background:"#dc2626" }}/>
              </div>
              <div style={{ display:"flex", gap:12, fontSize:11, color:"#6b7280", marginBottom:6 }}>
                <span><b style={{ color:"#2563eb" }}>🏠 {pred.home}</b> %{aiHp}</span>
                <span><b style={{ color:"#d97706" }}>🤝 Ber.</b> %{aiDp}</span>
                <span><b style={{ color:"#dc2626" }}>✈️ {pred.away}</b> %{aiAp}</span>
              </div>
              {pred.odds_bookmakers > 0 ? (
                <div style={{ padding:"3px 8px", background:"#f0fdf4", borderRadius:4, border:"1px solid #bbf7d0", fontSize:11 }}>
                  <b style={{ color:"#15803d" }}>📊 Piyasa</b>
                  <span style={{ color:"#166534", marginLeft:6 }}>🏠 %{pred.odds_ev} · 🤝 %{pred.odds_ber} · ✈️ %{pred.odds_dep}</span>
                  <span style={{ color:"#6b7280", marginLeft:6 }}>({pred.odds_bookmakers} bookie)</span>
                </div>
              ) : (
                <div style={{ padding:"3px 8px", background:"#f9fafb", borderRadius:4, border:"1px solid #e5e7eb", fontSize:11, color:"#9ca3af" }}>📊 Piyasa verisi yok</div>
              )}
              {aiReason && (
                <div style={{ fontSize:11, color:"#374151", lineHeight:1.6, background:"#fff", borderRadius:5, padding:"6px 10px", border:"1px solid #e5e7eb", marginTop:6 }}>💬 {aiReason}</div>
              )}
            </>
          )}
        </div>
      )}

      {/* Rapor sekmeleri */}
      <div style={{ display:"flex", borderBottom:"1px solid #eee", flexShrink:0, overflowX:"auto", padding:"0 8px" }}>
        {[["form","📊 Form"],["stats","📈 İstatistik"],["news","📰 Haberler"],
          ["home_case","🏠 Ev"],["away_case","✈️ Dep"],["odds","📊 Piyasa"],
          ["kalibrasyon","🎯 Kalibrasyon"]].map(([k,v]) => (
          <button key={k} onClick={() => setActiveReport(k)} style={{
            padding:"6px 10px", fontSize:11, border:"none", background:"none", cursor:"pointer", whiteSpace:"nowrap",
            borderBottom: activeReport===k ? "2px solid #111827" : "2px solid transparent",
            color: activeReport===k ? "#111827" : "#9ca3af", fontWeight: activeReport===k ? 600 : 400,
          }}>{v}</button>
        ))}
      </div>

      {/* Rapor içeriği */}
      <div style={{ flex:1, overflow:"auto", padding:"10px 14px" }}>
        {activeReport === "kalibrasyon" ? (
          <KalibrasyonView pred={pred} />
        ) : reports ? (
          activeReport === "odds" ? (
            pred.odds_bookmakers > 0 ? (
              <div>
                <div style={{ marginBottom:10, fontWeight:600, color:"#15803d", fontSize:13 }}>📊 Piyasa Oranları ({pred.odds_bookmakers} Bookmaker)</div>
                {[[`🏠 ${pred.home} Kazanır`, pred.odds_ev, "#2563eb"],["🤝 Beraberlik", pred.odds_ber, "#d97706"],[`✈️ ${pred.away} Kazanır`, pred.odds_dep, "#dc2626"]].map(([label, pct, color]) => (
                  <div key={label} style={{ marginBottom:10 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:3 }}>
                      <span style={{ fontSize:12, fontWeight:600, color }}>{label}</span>
                      <span style={{ fontSize:15, fontWeight:800, color }}>%{pct}</span>
                    </div>
                    <div style={{ height:7, background:"#e5e7eb", borderRadius:4, overflow:"hidden" }}>
                      <div style={{ width:`${pct}%`, height:"100%", background:color, borderRadius:4 }}/>
                    </div>
                  </div>
                ))}
              </div>
            ) : <div style={{ textAlign:"center", padding:"24px 16px", color:"#9ca3af", fontSize:12 }}>Piyasa verisi mevcut değil</div>
          ) : (
            <div style={{ fontSize:13, lineHeight:1.75, color:"#374151", whiteSpace:"pre-wrap", maxWidth:760 }}>
              {reports[activeReport] || "Bu rapor mevcut değil."}
            </div>
          )
        ) : (
          <div style={{ color:"#9ca3af", textAlign:"center", padding:32, fontSize:12 }}>
            {aiTab==="claude" ? "Claude" : "GPT-4o"} analizi henüz yapılmamış.
          </div>
        )}
      </div>
    </div>
  );
}

export default function BulkPredict({ queue, onAdd, onClearDone, currentLeague, predictions, userAnalysisEnabled = true }) {
  const prevWaiting = useRef(0);
  const [league, setLeague] = useState(currentLeague || "Tüm Ligler");
  const [matches, setMatches] = useState([]);
  const [loadingMatches, setLoadingMatches] = useState(true);
  const [checked, setChecked] = useState({});
  const [allChecked, setAllChecked] = useState(false);
  const [selectedPred, setSelectedPred] = useState(null);
  const isMobile = useIsMobile();

  const waitingCount = (queue||[]).filter(q=>q.status==="waiting"||q.status==="loading"||q.status==="polling").length;

  // Analiz bitince predictions'ı yenile
  useEffect(() => {
    if (prevWaiting.current > 0 && waitingCount === 0) {
      if (onClearDone) onClearDone();
    }
    prevWaiting.current = waitingCount;
  }, [waitingCount, onClearDone]);

  useEffect(() => {
    if (currentLeague) setLeague(currentLeague);
    else if (!currentLeague && currentLeague !== undefined) setLeague("Tüm Ligler");
  }, [currentLeague]);

  useEffect(() => {
    // Lig değişince açık maç raporunu kapat — aksi halde başka ligin maçı
    // sağ panelde asılı kalıyor ("Bu hafta maç yok" iken eski analiz görünür).
    setSelectedPred(null);
    if (league === "Tüm Ligler") {
      // Tüm Ligler modunda maç listesi gerekmez
      setMatches([]);
      setLoadingMatches(false);
      return;
    }
    setLoadingMatches(true);
    setChecked({});
    setAllChecked(false);
    const { start, end } = getWeekRange();
    api.matches(league, 500).then(d => {
      const all = (d.matches || []).filter(m => m.date >= start && m.date <= end);
      setMatches(all);
      setLoadingMatches(false);
    }).catch(() => setLoadingMatches(false));
  }, [league]);

  const toggleAll = val => {
    setAllChecked(val);
    const next = {};
    matches.filter(m => !m.home_goals).forEach((_, i) => { next[i] = val; });
    setChecked(next);
  };

  const pendingMatches = matches.filter(m => m.home_goals == null);
  const checkedMatches = pendingMatches.filter((_, i) => checked[i]);

  const handleAnalyze = () => {
    if (checkedMatches.length === 0) return;
    onAdd(checkedMatches, league, predictions);
    setChecked({});
    setAllChecked(false);
  };

  return (
    <div style={{ display:"flex", height:"100%", overflow:"hidden" }}>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>

      {/* Sol: Maç listesi — master liste. Masaüstünde geniş ekranda büyümesin
          diye üst sınır; rapor açıkken asıl alanı rapora bırakır. Mobilde tam
          genişlik ve bir maç seçilince gizlenir (yan yana çift kolon olmaz —
          sayfa atlatarak rapora geçilir). */}
      <div style={ isMobile
        ? { flex:1, width:"100%", minWidth:0, overflowY:"auto", display: selectedPred ? "none" : "block" }
        : { flex:"0 1 40%", maxWidth:460, minWidth:300, overflowY:"auto", borderRight:"1px solid #e5e5e5" } }>

        {/* Lig seçici */}
        <div style={{ padding:"10px 12px", borderBottom:"1px solid #eee", display:"flex", gap:8, alignItems:"center", background:"#fafafa", flexShrink:0 }}>
          <select value={league} onChange={e => setLeague(e.target.value)}
            style={{ flex:1, padding:"6px 10px", border:"1px solid #e5e5e5", borderRadius:6, fontSize:13, background:"#fff" }}>
            <option value="Tüm Ligler">🌍 Tüm Ligler</option>
            {ALL_LEAGUES.map(l => <option key={l}>{l}</option>)}
          </select>
          {checkedMatches.length > 0 && (
            <button onClick={handleAnalyze}
              style={{ padding:"6px 14px", borderRadius:6, border:"none", background: userAnalysisEnabled ? "#2563eb" : "#d1d5db", color:"#fff", fontSize:12, fontWeight:600, cursor: userAnalysisEnabled ? "pointer" : "not-allowed", whiteSpace:"nowrap" }}
              disabled={!userAnalysisEnabled}
              title={!userAnalysisEnabled ? "Analiz şu an devre dışı" : ""}>
              🎯 {checkedMatches.length} Analiz Et
            </button>
          )}
        </div>



        {loadingMatches && <div style={{ padding:32, textAlign:"center", color:"#aaa", fontSize:13 }}>Yükleniyor...</div>}

        {/* Tüm Ligler modu — günün maçları (tüm ligler, canlı skorlarla).
            Eskiden bekleyen tahmin listesiydi; artık Ana Sayfa'dan taşınan
            günün maçları görünümü. Bekleyen/geçmiş tahminler Geçmiş sayfasında. */}
        {!loadingMatches && league === "Tüm Ligler" && (
          <GununMaclari
            predictions={predictions}
            queue={queue}
            onAdd={onAdd}
            onView={setSelectedPred}
            userAnalysisEnabled={userAnalysisEnabled}
          />
        )}

        {!loadingMatches && league !== "Tüm Ligler" && matches.length === 0 && (
          <div style={{ padding:48, textAlign:"center", color:"#bbb", fontSize:13 }}>Bu hafta maç yok</div>
        )}

        {!loadingMatches && league !== "Tüm Ligler" && matches.length > 0 && (() => {
          const played = matches.filter(m => m.home_goals != null);
          const pending = matches.filter(m => m.home_goals == null);
          return (
            <>
              {/* Oynanmış maçlar */}
              {played.length > 0 && (
                <div>
                  <div style={{ padding:"6px 12px", fontSize:11, color:"#9ca3af", fontWeight:600, textTransform:"uppercase", letterSpacing:".05em", background:"#f9fafb" }}>
                    Tamamlanan — {played.length} maç
                  </div>
                  {played.map((m, i) => {
                    const pred = (predictions||[]).find(p => p.home === m.home && p.away === m.away);
                    return (
                      <div key={i} onClick={() => pred && setSelectedPred(pred)}
                        style={{ display:"flex", alignItems:"center", padding:"8px 12px", borderBottom:"1px solid #f0f0f0",
                          background: pred ? "#f9fffe" : "#fff", cursor: pred ? "pointer" : "default", gap:8 }}>
                        <div style={{ width:14 }} />
                        <div style={{ width:36, fontSize:11, color:"#9ca3af", textAlign:"center" }}>FT</div>
                        <div style={{ flex:1, textAlign:"right", fontSize:13, fontWeight: m.home_goals > m.away_goals ? 700 : 400, color:"#222", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", paddingRight:8 }}>{m.home}</div>
                        <div style={{ width:52, textAlign:"center" }}>
                          <span style={{ fontSize:12, fontWeight:700, color:"#333", background:"#f0f0f0", padding:"2px 6px", borderRadius:4 }}>
                            {m.home_goals} - {m.away_goals}
                          </span>
                        </div>
                        <div style={{ flex:1, fontSize:13, fontWeight: m.away_goals > m.home_goals ? 700 : 400, color:"#222", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", paddingLeft:8 }}>{m.away}</div>
                        <div style={{ width:52, textAlign:"right" }}>
                          {pred && <span style={{ fontSize:11, padding:"2px 7px", borderRadius:3, background:"#16a34a", color:"#fff", fontWeight:700 }}>{predCode(pred.gpt_prediction || pred.prediction)}</span>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Oynanacak maçlar */}
              {pending.length > 0 && (
                <div>
                  <div style={{ padding:"6px 12px", fontSize:11, color:"#9ca3af", fontWeight:600, textTransform:"uppercase", letterSpacing:".05em", background:"#f9fafb", display:"flex", alignItems:"center", gap:8 }}>
                    <label style={{ display:"flex", alignItems:"center", gap:6, cursor:"pointer", fontSize:11, color:"#6b7280" }}>
                      <input type="checkbox" checked={allChecked} onChange={e => toggleAll(e.target.checked)} style={{ width:13, height:13 }}/>
                      Tümü
                    </label>
                    <span style={{ marginLeft:"auto" }}>Oynanacak — {pending.length} maç</span>
                  </div>
                  {pending.map((m, i) => {
                    const pred = (predictions||[]).find(p => p.home === m.home && p.away === m.away);
                    const qItem = (queue||[]).find(q => q.home === m.home && q.away === m.away);
                    const qStatus = qItem?.status;
                    const qAnaliz = qStatus==="loading" || qStatus==="polling";
                    const code = predCode(pred?.gpt_prediction || pred?.prediction);
                    const rowBg = qAnaliz ? "#fffbeb" : qStatus==="waiting" ? "#fefce8" : checked[i] ? "#eff6ff" : "#fff";
                    return (
                      <div key={i} onClick={() => pred && setSelectedPred(pred)}
                        style={{ display:"flex", alignItems:"center", padding:"8px 12px", borderBottom:"1px solid #f0f0f0", background:rowBg, gap:8, cursor: pred ? "pointer" : "default" }}>
                        <input type="checkbox" checked={!!checked[i]}
                          onChange={e => { e.stopPropagation(); setChecked(prev => ({ ...prev, [i]: e.target.checked })); if (!e.target.checked) setAllChecked(false); }}
                          style={{ width:14, height:14, cursor:"pointer", flexShrink:0 }} />
                        <div style={{ width:36, fontSize:11, color:"#aaa", textAlign:"center" }}>{m.time || ""}</div>
                        <div style={{ flex:1, textAlign:"right", fontSize:13, fontWeight:500, color:"#222", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", paddingRight:8 }}>{m.home}</div>
                        <div style={{ width:52, textAlign:"center" }}><span style={{ fontSize:11, color:"#ddd" }}>vs</span></div>
                        <div style={{ flex:1, fontSize:13, fontWeight:500, color:"#222", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", paddingLeft:8 }}>{m.away}</div>
                        <div style={{ width:52, textAlign:"right", flexShrink:0 }}>
                          {qAnaliz ? <span style={{ fontSize:14, animation:"spin 1s linear infinite" }}>⏳</span>
                           : qStatus==="waiting" ? <span style={{ fontSize:14, opacity:.5 }}>⏸</span>
                           : code ? <span style={{ fontSize:11, padding:"2px 7px", borderRadius:3, background:"#16a34a", color:"#fff", fontWeight:700 }}>{code}</span>
                           : null}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          );
        })()}
      </div>

      {/* Sağ: İstatistik + Rapor — baskın panel, kalan tüm alanı alır. Mobilde
          tam genişlik ve yalnızca bir maç seçiliyken görünür. */}
      <div style={ isMobile
        ? { flex:1, width:"100%", minWidth:0, display: selectedPred ? "flex" : "none", flexDirection:"column", overflow:"hidden" }
        : { flex:1, minWidth:0, borderLeft:"1px solid #e5e5e5", display:"flex", flexDirection:"column", overflow:"hidden" } }>
        {/* Mobilde listeye dönüş için üst bar */}
        {isMobile && selectedPred && (
          <button onClick={() => setSelectedPred(null)}
            style={{ display:"flex", alignItems:"center", gap:6, padding:"10px 14px", border:"none",
                     borderBottom:"1px solid #eee", background:"#fafafa", fontSize:13, fontWeight:600,
                     color:"#2563eb", cursor:"pointer", flexShrink:0, width:"100%", textAlign:"left" }}>
            ‹ Maç listesine dön
          </button>
        )}
        <LeagueStats league={league} predictions={predictions||[]} compact={!!selectedPred} />
        <div style={{ flex:1, overflow:"hidden" }}>
          <ReportPanel prediction={selectedPred} onClose={() => setSelectedPred(null)} />
        </div>
      </div>
    </div>
  );
}
